import { css } from "@emotion/react";
import { match } from "ts-pattern";

import { UserQuestProgressStatus } from "~/lib/graphql/client";

const UserQuestProgressStatusLabel = ({
  status,
}: {
  status: UserQuestProgressStatus;
}) => {
  const progressStatusLabel = match(status)
    .with(UserQuestProgressStatus.NotRequestedYet, () => "進行前")
    .with(UserQuestProgressStatus.Doing, () => "進行中")
    .with(UserQuestProgressStatus.UnderReviewing, () => "レビュー中")
    .with(UserQuestProgressStatus.Verified, () => "完了")
    .exhaustive();

  const iconInnerColor = match(status)
    .with(UserQuestProgressStatus.NotRequestedYet, () => "#FFF4CF")
    .with(UserQuestProgressStatus.Doing, () => "#FF480F")
    .with(UserQuestProgressStatus.UnderReviewing, () => "#FF480F")
    .with(UserQuestProgressStatus.Verified, () => "#4AE800")
    .exhaustive();

  if (status === UserQuestProgressStatus.NotRequestedYet) {
    return null;
  }

  return (
    <span css={questStatusIconStyle(iconInnerColor)}>
      {progressStatusLabel}
    </span>
  );
};

const questStatusIconStyle = (iconInnerColor: string) => css`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  &::after {
    box-sizing: border-box;
    content: "";
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 50%;
    background-color: ${iconInnerColor};
    border: 1px solid #aaa;
  }
`;

export default UserQuestProgressStatusLabel;
